var map = {
	"./img-skin01.jpg": 86216,
	"./img-skin02.jpg": 8535,
	"./img-skin03.jpg": 56602,
	"./img-skin04.jpg": 46089,
	"./img-skin05.jpg": 48300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78224;